import styled from 'styled-components';

type WrapperProps = {
  flexDirection?: 'row' | 'column';
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  alignItems?: 'flex-start' | 'center' | 'flex-end';
  width?: string;
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: ${(props: WrapperProps) =>
    props.flexDirection ? props.flexDirection : 'column'};
  height: 100%;
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : 'space-between'};
  align-items: ${props => (props.alignItems ? props.alignItems : 'flex-start')};
  width: ${props => (props.width ? props.width : '100%')};
`;
